import { Box } from 'modules/v2/foundation/Box';
import { Typography } from 'modules/v2/foundation/Typography';
import { themeGet } from 'modules/v2/foundation/theme';
import { Avatar } from '../../Avatar';
import { AvatarWrapper, StyledListItem } from './styled';
export function AccordionItemElement(props) {
    const { icon, title, subtitle, endElement, reverseTexts = false, onClick } = props;
    const handleEndElementClick = (event) => {
        event.stopPropagation();
    };
    const titleStyle = {
        lineHeight: !icon && !subtitle ? 1 : themeGet('lineHeight.neutralized'),
    };
    return (<StyledListItem $noHoverEffect={onClick === undefined} onClick={onClick}>
      {icon && (<AvatarWrapper>
          <Avatar size="sm" appearance="light">
            {icon}
          </Avatar>
        </AvatarWrapper>)}
      <Box flexDirection={reverseTexts ? 'column-reverse' : 'column'} alignItems="flex-start">
        <Typography $appearance={subtitle ? '300' : '100'} $fontSize="tiny" $fontWeight="medium" style={titleStyle}>
          {title}
        </Typography>
        {subtitle && (<Typography $appearance="100" $fontSize="tiny" $lineHeight="neutralized">
            {subtitle}
          </Typography>)}
      </Box>
      {endElement && (<Box ml="auto" onClick={handleEndElementClick}>
          {endElement}
        </Box>)}
    </StyledListItem>);
}
